export const GET_WIND_ISO_LIMITS = "GET_WIND_ISO_LIMITS";
export const GET_WIND_ISO_LIMITS_SUCCESS = "GET_WIND_ISO_LIMITS_SUCCESS";
export const GET_WIND_ISO_LIMITS_ERROR = "GET_WIND_ISO_LIMITS_ERROR";
